import React, {useState} from 'react'
import { registerNew } from '../Services/allAPIs'
import { motion} from 'framer-motion'

function Registration() {

  const [courses, setCourses] = useState([])

  const [normalInput,setNormalInput] = useState({
    name:"",
    phone:"",
    email:"",
  })

  const setUserInputs = (e) =>{
    console.log(e.target);
    const {name,value} = e.target
    setNormalInput({...normalInput,[name]:value})
  }

  
  const selectCourses = (e) =>{
    const {value,checked} =e.target
    console.log(`${value} is ${checked}`);
    if(checked){
      setCourses([...courses,value])
    }else{
      setCourses(courses.filter((e) => e!==value))
    }
  }

  const Register = async (e) => {
    e.preventDefault();
    console.log("Hey");
    const {name,phone,email} = normalInput
    if(!name || !phone || !email || !courses){
      alert("Please Fill the Form Completely")
    }
    else{
      const data = {
        name:name,
        phone:phone,
        email:email,
        courses:courses
      };
      console.log(data);
      
      const response = await registerNew(data)
      console.log(response);
      if(response.status === 200){
        alert("Registerd Successfully")
        setNormalInput({...normalInput,
          name:"",
          phone:"",
          email:"",
        })
        setCourses([])
      }
      else{
        alert("Error Not Registered")
      }
      
    }
  }

  return (
    <>
      <motion.div className='row mt-5'
        variants={{
          hidden:{opacity:0},
          visible:{opacity:1}
        }}
        initial="hidden"
        animate="visible"
        transition={{duration:2,delay:0}}
      >
        <div className='col-lg-4 col-2'></div>
        <div className='col-lg-4 col-8 d-flex flex-column justify-content-center align-items-center' style={{background: "linear-gradient(50deg, #FFFFFF 50%, #999999 )",borderRadius:"50px"}}>
        <h3 className='d-flex justify-content-center mt-5'>Register</h3>
          <form onSubmit={Register}>
            <div className='col-12'>
              <label class="form-label">Name</label>
              <input type="text" class="form-control" name="name" value={normalInput.name} onChange={setUserInputs}/>
            </div>

            <div className='row'>
              <div className='col-6'>
                <label class="form-label">Phone</label>
                <input type="text" class="form-control" name='phone' value={normalInput.phone} onChange={setUserInputs}/>
              </div>

              <div className='col-6'>
                <label class="form-label">Email</label>
                <input type="email" class="form-control" name="email" value={normalInput.email} onChange={setUserInputs}/>
              </div>
            </div>
            
            <p className='mt-3'>
              <strong>Choose Your Course</strong>
            </p>
            <div class="form-check ms-3">
              <input class="form-check-input" type="checkbox" name="courses" id="flexRadioDefault1" value={"Piano"} onChange={(e)=>selectCourses(e)}/>
              <label class="form-check-label" for="flexRadioDefault1">
                Piano
              </label>
            </div>
            <div class="form-check ms-3 mt-2">
              <input class="form-check-input" type="checkbox" name="courses" id="flexRadioDefault2" value={"Western Vocals"} onChange={(e)=>selectCourses(e)}/>
              <label class="form-check-label" for="flexRadioDefault2">
                Western Vocals
              </label> 
            </div>
            
            <div className='row mt-5'>
              <div className='col-4'></div>
              <div className='col-4'>
                <button className='btn btn-dark rounded-pill' type='submit' value="send">Submit</button>
              </div>
              <div className='col-4'></div>
            </div>
          </form>
        </div>
        <div className='col-lg-4 col-2'></div>
      </motion.div>
    </>
  )
}

export default Registration